"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _reactCustomScrollbars = _interopRequireDefault(require("react-custom-scrollbars"));
var _Grow = _interopRequireDefault(require("@mui/material/Grow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
var _HiSelectableList = _interopRequireDefault(require("../HiSelectableList"));
var _HiInput = _interopRequireDefault(require("../HiForm/HiInput"));
var _HiSelectInput = _interopRequireDefault(require("./HiSelectInput"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _helpers = require("../utils/helpers");
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _keycode = _interopRequireDefault(require("keycode"));
var _classnames = _interopRequireDefault(require("classnames"));
var _HiAlertModal = _interopRequireDefault(require("../HiAlertModal"));
var _reactDeviceDetect = require("react-device-detect");
var _HiSelectMobile = _interopRequireDefault(require("./HiSelectMobile"));
var _reactDom = require("react-dom");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background2,
      width: '100%',
      position: 'relative'
    },
    popper: {
      zIndex: 1200
    },
    popperWidth: {
      width: '100% !important'
    },
    popperRightAlign: {
      right: 0,
      left: 'unset!important'
    },
    paper: {
      borderRadius: '0px 2px',
      maxHeight: 480,
      transition: 'none !important'
    },
    labelIcon: {
      marginRight: 10,
      verticalAlign: 'text-bottom'
    },
    labelImg: {
      height: 18,
      width: 'auto',
      margin: '0 4px',
      verticalAlign: 'text-bottom'
    },
    selectIconLabel: (0, _objectSpread2.default)({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: 16
    }, theme.typography.body2, {
      display: 'inline-block',
      width: '100%'
    }),
    selectImgLabel: (0, _objectSpread2.default)({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: 16
    }, theme.typography.body2, {
      display: 'inline-flex',
      width: '100%'
    }),
    separator: {
      borderTop: "1px solid ".concat(theme.palette.input.bottomLine)
    }
  };
};
function filterValue(item, search) {
  return search === '' || (0, _helpers.foldAccents)(item.label.toString().toLowerCase()).search((0, _helpers.foldAccents)(search.toLowerCase())) !== -1;
}

/**
 *
 * Utilisé pour tous types de selects dans les formulaires.
 * - single / multiple ( multi-select )
 * - avec / sans checkboxes
 * - avec / sans barre de recherche
 * - avec / sans option "All"
 * - prise en compte du type des éléments (text, image, icon, ...)
 * - les actions du clavier son capturés avec KeyDown
 *
 * Ce composant réuni les sous-composants
 * - HiSelectInput : affiche l'élément dans le formulaire
 * - HiSearchField : intègre une barre de recherche dans le Popper, il filtre la liste des suggestions
 * - HiSelectableList : affiche la liste des suggestions selon le type des éléments
 */
var HiSelect = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelect(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelect);
    _this = _callSuper(this, HiSelect, [_props]);
    /**
     * Build itemList & inputValue from select props
     * @param options
     * @param value
     * @param search
     * @param loading
     * @returns {{itemList: *[], inputValue: *}}
     */
    _this.buildSelectProps = function (options) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      // build item list
      var itemList = [].concat((0, _toConsumableArray2.default)(loading ? [{
        id: '_loading',
        type: 'loader',
        disabled: true,
        centered: true,
        hideCheckbox: true,
        label: 'loading'
      }] : []), (0, _toConsumableArray2.default)(search !== '' ? (0, _toConsumableArray2.default)(options.filter(function (item) {
        return _this.props.filterFunc(item, search);
      })) : [].concat((0, _toConsumableArray2.default)(_this.props.hasAll ? [(0, _objectSpread2.default)({
        id: '_all',
        label: _this.props.translations.all
      }, _this.props.iconAll && {
        type: 'icon',
        icon: _this.props.iconAll
      })] : []), (0, _toConsumableArray2.default)(options))));
      return {
        itemList: itemList,
        inputValue: _this.buildInputValue(options, value, loading)
      };
    };
    _this.findRecursively = function (arr, id) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          return arr[i];
        } else if (arr[i].children && arr[i].children.length) {
          var found = _this.findRecursively(arr[i].children, id);
          if (found) return found;
        }
      }
    };
    _this.buildInputValue = function (options) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
        classes = _this$props.classes,
        hasAll = _this$props.hasAll,
        translations = _this$props.translations,
        type = _this$props.type; // build input value
      var inputValue;
      if (loading && value.length === 1) {
        inputValue = translations.one_item_selected;
      } else if (hasAll && options.length === value.length) {
        inputValue = translations.all;
        value.unshift('_all');
      } else if (value.length > 1) {
        inputValue = translations.n_items_selected.replace('%s', value.length);
      } else if (value.length === 1) {
        var item = _this.findRecursively(options, value[0]);
        if (item === undefined) {
          inputValue = translations.one_item_selected;
        } else if (type === 'icon' || item.type === 'icon') {
          var iconProps = {
            className: classes.labelIcon,
            color: item.color
          };
          var icon;
          if (typeof item.icon === 'string') {
            icon = /*#__PURE__*/_react.default.createElement(_HiIcon.default, (0, _extends2.default)({
              icon: item.icon
            }, iconProps));
          } else if ((0, _typeof2.default)(item.icon) === 'object') {
            icon = (0, _objectSpread2.default)({}, item.icon);
            icon.props = (0, _objectSpread2.default)({}, icon.props, {}, iconProps);
          }
          inputValue = /*#__PURE__*/_react.default.createElement("span", {
            className: classes.selectIconLabel
          }, icon, item.label);
        } else if (type === 'image' || item.type === 'image') {
          inputValue = /*#__PURE__*/_react.default.createElement("span", {
            className: classes.selectIconLabel
          }, item.img && /*#__PURE__*/_react.default.createElement("img", {
            className: classes.labelImg,
            src: item.img,
            alt: item.label,
            onError: function onError(e) {
              if (item.fallbackImage) {
                e.target.src = "".concat(item.fallbackImage);
              } else {
                e.target.style.display = 'none';
              }
            }
          }), item.label);
        } else {
          inputValue = item.label;
        }
      }
      return inputValue;
    };
    _this.focusOnFirstItem = function () {
      if (_this.overlay && _this.overlay.querySelector('li:not([tabindex^="-"])')) {
        setTimeout(function () {
          var item = _this.overlay.querySelector('li:not([tabindex^="-"])');
          item.focus();
        }, 1);
      }
    };
    _this.getInputElement = function (el) {
      _this.searchField = el;
      if (_this.props.inputRef) {
        _this.props.inputRef(_this.searchField);
      }
    };
    _this.handleBlur = function (event) {
      _this.handleSearchReset();
      _this.setState({
        focused: false
      });
      if (_this.props.onBlur && !_this.inputEl.contains(event.relatedTarget) && !_this.state.open) {
        _this.props.onBlur(event);
      }
    };
    _this.handleClick = function (event) {
      if (_this.state.open) {
        _this.handleClose();
      } else if (_this.props.alert && !_this.state.alertOpen) {
        _this.setState({
          open: false,
          alertOpen: true
        });
      } else {
        _this.setState({
          open: true,
          alertOpen: false
        });
        _this.handleSuggestions(_this.props.options);
        if (_this.props.onClick) _this.props.onClick();

        // Gestion du focus
        setTimeout(function () {
          if (!_this.props.searchable) {
            // Sinon focus sur l'élément sélectionné
            _this.focusOnSelectedItem(_this.props.value);
          }
        }, 1);
      }
    };
    _this.handleSubmitAlert = function () {
      _this.handleClick();
    };
    _this.handleCancelAlert = function () {
      _this.handleClose();
    };
    _this.handleExitedAlert = function () {
      if (_this.searchField) {
        _this.searchField.focus();
      }
    };
    _this.handleCloseAlert = function () {
      _this.handleClose();
    };
    _this.focusOnSelectedItem = function (selectedValue) {
      if (_this.overlay && _this.overlay.querySelector('li:not([tabindex^="-"])')) {
        setTimeout(function () {
          if (_this.overlay) {
            // On initialise au premier élément pour être sûr de ne pas se retrouver avec un focus of undefined
            var item = _this.overlay.querySelector('li:not([tabindex^="-"])');
            if (selectedValue && typeof selectedValue === 'string') {
              item = _this.overlay.getElementsByTagName('li').namedItem(selectedValue);
            } else if (selectedValue && typeof selectedValue === 'number') {
              item = _this.overlay.querySelector('li:not([tabindex^="-"])')[selectedValue - 1];
            }
            if (item) {
              item.focus();
            }
          }
        }, 1);
      }
    };
    _this.handleClickAway = function (event) {
      // Au clic sur le bouton, on laisse le handleClick fermer le select
      if (!_this.inputEl.contains(event.target)) {
        _this.handleClose(event);
      }
    };
    _this.handleClose = function () {
      _this.handleSearchReset();
      _this.setState({
        open: false,
        alertOpen: false
      });
      if (_this.props.onClose) {
        _this.props.onClose();
      }
      if (_this.inputEl) {
        setTimeout(function () {
          _this.inputEl.focus();
        }, 100);
      }
    };
    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };
    // Stop the propagation of the event before it reach the childrens
    _this.handleKeyDownCapture = function (event) {
      var key = (0, _keycode.default)(event);
      if (key === 'enter') {
        if (_this.state.open) {
          if (_this.props.multiple) {
            event.stopPropagation();
            _this.handleClose();
          }
        }
      }
    };
    // Key down on input
    _this.handleKeyDown = function (event) {
      var key = (0, _keycode.default)(event);
      if (!_this.state.alertOpen) {
        if (event.target === _this.inputEl && _this.state.open && key === 'down') {
          // Focus on list 1st item
          event.stopPropagation();
          event.preventDefault();
          var firstLi = document.querySelector("#".concat(_this.props.id, " + div ul > li"));
          if (!!firstLi) {
            firstLi.focus();
          }
        } else if (key === 'esc' && _this.state.open) {
          event.stopPropagation();
          event.preventDefault();
          _this.handleClose();
        } else if (key === 'enter') {
          if (_this.state.open) {
            if (_this.props.multiple) {
              _this.handleClose();
            }
          }
        } else if (key === 'space' && event.target !== _this.searchField) {
          event.preventDefault();
        } else if (key === 'tab' && (_this.state.open || _this.state.alertOpen)) {
          event.stopPropagation();
          _this.handleClose();
        } else if (key === 'down' && event.target.id.includes('_subheader')) {
          // Focus on parent, next item is child
          if (document.querySelector("#group-".concat(event.target.id, " li:nth-child(1)"))) {
            document.querySelector("#group-".concat(event.target.id, " li:nth-child(1)")).focus();
          }
        } else if (key === 'down' && !event.target.nextSibling) {
          var _document$getElementB, _document$getElementB2;
          // Focus on parent, next item is child
          if ((_document$getElementB = document.getElementById(event.target.dataset.group)) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.nextSibling) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.nextSibling) {
            document.getElementById(event.target.dataset.group).nextSibling.nextSibling.focus();
          }
        } else if (key === 'up') {
          if (event.target.previousSibling === null && !!event.target.dataset.group) {
            // Previous item is parent item
            document.getElementById(event.target.dataset.group).focus();
          } else if (!!event.target.previousSibling && !event.target.dataset.group) {
            // On parent, go to previous (last) child
            if (event.target.previousSibling.querySelector('li:last-child')) {
              event.target.previousSibling.querySelector('li:last-child').focus();
            }
          }
        }
      }
    };
    // Key down on search input
    _this.handleKeyDownSearch = function (event) {
      var key = (0, _keycode.default)(event);
      if (_this.overlay && (key === 'down' || key === 'up')) {
        _this.focusOnFirstItem();
      } else if (_this.overlay && (key === 'esc' || key === 'enter')) {
        event.preventDefault();
        _this.handleClose();
      } else if (key === 'tab') {
        _this.setState({
          open: false
        });
      }
    };
    /**
     * Call onScrollReachBottom
     * @param e
     */
    _this.handleScroll = function (e) {
      if (e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop < 15) {
        _this.props.onScrollReachBottom();
      }
    };
    /**
     * Call onChange with the updated value
     *
     * - handle single value
     * - handle multiple value
     * - handle '_all' id
     *
     * @param event
     * @param item
     */
    _this.handleSelect = function (event, item) {
      var _this$props2 = _this.props,
        hasAll = _this$props2.hasAll,
        multiple = _this$props2.multiple,
        onChange = _this$props2.onChange,
        options = _this$props2.options,
        value = _this$props2.value;
      if (!multiple) {
        // This is a fix to prevent select open after select => TODO improve ?
        setTimeout(function () {
          // single value
          _this.handleClose();
        }, 1);
        onChange(event, item.id, item);
      } else if (hasAll && item.id === '_all') {
        if (value.length === options.length) {
          // unselect _all options
          onChange(event, [], item);
        } else {
          // select _all options
          onChange(event, options.map(function (option) {
            return option.id;
          }), item);
        }
      } else if (_reactDeviceDetect.isMobile && multiple) {
        // Array of selected values
        onChange(event, item.map(function (option) {
          return option.id;
        }), item);
      } else if (value.includes(item.id)) {
        // unselect item
        onChange(event, value.filter(function (id) {
          return id !== item.id;
        }), item);
      } else {
        onChange(event, [].concat((0, _toConsumableArray2.default)(value), [item.id]), item);
      }
    };
    /**
     * Update suggestions list
     * - add '_no_result' item if suggestion list is empty
     * - add '_all' item if suggestion list is complete
     * @param suggestions
     */
    _this.handleSuggestions = function (suggestions) {
      var _this$props3 = _this.props,
        hasAll = _this$props3.hasAll,
        iconAll = _this$props3.iconAll,
        translations = _this$props3.translations;
      if (suggestions.length === 0) {
        // Add '_no_result' suggestion
        _this.setState(function (prevState) {
          return (0, _objectSpread2.default)({}, prevState, {
            suggestions: [{
              id: '_no_result',
              type: 'text',
              disabled: true,
              centered: true,
              hideCheckbox: true,
              label: translations.no_result_match
            }]
          });
        });
      } else {
        _this.setState({
          suggestions: [].concat((0, _toConsumableArray2.default)(hasAll ? [(0, _objectSpread2.default)({
            id: '_all',
            label: translations.all
          }, iconAll && {
            type: 'icon',
            icon: iconAll
          })] : []), (0, _toConsumableArray2.default)(suggestions))
        });
      }
    };
    _this.handleSearch = function (e, inputValue) {
      var searchValue = inputValue && e.target.value ? inputValue : e.target.value;
      if (_this.props.onSearch) {
        _this.props.onSearch(e, searchValue);
      } else {
        _this.setState({
          searchValue: searchValue
        });
      }
    };
    _this.handleSearchReset = function () {
      _this.handleSearch({
        target: {
          value: ''
        }
      }, '');
    };
    _this.getLengthItemList = function (itemList) {
      var itemListLength = 0;
      itemList.forEach(function (parent) {
        if (parent.displayed !== false) {
          itemListLength += 1;
          if (parent.children) {
            itemListLength += _this.getLengthItemList(parent.children);
          }
        }
      });
      return itemListLength;
    };
    _this.renderScrollbarTrackHorizontal = function (props) {
      var style = props.style,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["style"]);
      var inlineStyle = (0, _objectSpread2.default)({}, style, {
        zIndex: 10,
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
      });
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        style: inlineStyle
      }));
    };
    _this.renderScrollbarTrackVertical = function (props) {
      var style = props.style,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["style"]);
      var inlineStyle = (0, _objectSpread2.default)({}, style, {
        zIndex: 10,
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
      });
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        style: inlineStyle
      }));
    };
    _this.state = {
      alertOpen: false,
      open: false,
      focused: false,
      searchValue: _props.searchValue ? undefined : '',
      suggestions: _props.options,
      openDown: true,
      overlayWidth: 0
    };
    return _this;
  }
  (0, _inherits2.default)(HiSelect, _React$PureComponent);
  return (0, _createClass2.default)(HiSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.inputEl.focus();
      }
      if (this.overlay) {
        this.setState({
          overlayWidth: (0, _reactDom.findDOMNode)(this.overlay).clientWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        alert = _this$props4.alert,
        classes = _this$props4.classes,
        disabled = _this$props4.disabled,
        error = _this$props4.error,
        loading = _this$props4.loading,
        options = _this$props4.options,
        searchable = _this$props4.searchable,
        displayAsChip = _this$props4.displayAsChip,
        type = _this$props4.type,
        value = _this$props4.value,
        multiple = _this$props4.multiple,
        translations = _this$props4.translations,
        hiSearchInputProps = _this$props4.hiSearchInputProps,
        hiSelectableListProps = _this$props4.hiSelectableListProps,
        hiSelectInputProps = _this$props4.hiSelectInputProps,
        id = _this$props4.id,
        onScrollReachBottom = _this$props4.onScrollReachBottom,
        onSubmit = _this$props4.onSubmit,
        placeholder = _this$props4.placeholder,
        _this$props4$searchVa = _this$props4.searchValue,
        searchValue = _this$props4$searchVa === void 0 ? this.state.searchValue : _this$props4$searchVa,
        startAdornment = _this$props4.startAdornment,
        staticPosition = _this$props4.staticPosition,
        maxOptionsDisplayed = _this$props4.maxOptionsDisplayed,
        _this$props4$buildSel = _this$props4.buildSelectProps,
        buildSelectProps = _this$props4$buildSel === void 0 ? this.buildSelectProps : _this$props4$buildSel;
      var _this$state = this.state,
        alertOpen = _this$state.alertOpen,
        open = _this$state.open,
        focused = _this$state.focused;
      if (multiple) {
        if (!Array.isArray(value)) {
          throw new Error('HiPay Material-UI: the `value` property must be an array ' + 'when using the `HiSelect` component with `multiple`.');
        }
      }
      var selectedItemIdList = [];
      if (value) {
        selectedItemIdList = multiple ? (0, _toConsumableArray2.default)(value) : [value];
      }
      var _buildSelectProps = buildSelectProps(options, selectedItemIdList, searchValue, loading),
        itemList = _buildSelectProps.itemList,
        _buildSelectProps$inp = _buildSelectProps.inputValue,
        inputValue = _buildSelectProps$inp === void 0 ? this.buildInputValue(options, selectedItemIdList, loading) : _buildSelectProps$inp;
      var popperStyle = {
        position: staticPosition ? 'relative' : 'fix',
        top: 0,
        left: 0
      };
      if (this.props.containerWidth > 0) {
        popperStyle = {
          width: this.props.containerWidth
        };
        if (!staticPosition) {
          popperStyle.position = 'absolute';
        }
      }
      var popperClass = (0, _classnames.default)(classes.popper, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.popperWidth, !this.props.containerWidth), classes.popperRightAlign, this.props.containerWidth && this.props.align === 'right'));
      var searchInput = function searchInput(position) {
        if (searchable) {
          return /*#__PURE__*/_react.default.createElement(_HiInput.default, (0, _extends2.default)({
            value: searchValue,
            autoFocus: true,
            inputRef: _this2.getInputElement,
            onKeyDown: _this2.handleKeyDownSearch,
            onChange: _this2.handleSearch,
            onReset: _this2.handleSearchReset,
            placeholder: translations.search,
            startAdornment: 'search',
            tabIndex: 0,
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.separator, position === 'top'))
          }, hiSearchInputProps));
        }
        return null;
      };

      // Replace popper onSearch when popper displayed on top of selectButton
      if (this.placement && this.placement.indexOf('top') >= 0 && !!searchable) {
        // In case we have a nested list
        var itemListLength = this.getLengthItemList(itemList);
        // +1 for search input
        var nbItems = itemListLength <= maxOptionsDisplayed - 2 ? itemListLength + 1 : maxOptionsDisplayed - 1;
        popperStyle.transform = "translate3d(-1px, -".concat(nbItems * 40 + 2, "px, 0px)");
      } else if (this.placement && this.placement.indexOf('top') < 0 && !!searchable) {
        popperStyle.transform = 'translate3d(-1px, 40px, 0px)';
      }
      var content = function content(_ref) {
        var placement = _ref.placement;
        if (placement !== _this2.placement) {
          _this2.placement = placement;
        }
        var nbItemsDisplayed = !!searchable ? maxOptionsDisplayed - 1 : maxOptionsDisplayed;
        var autoHeightMax = nbItemsDisplayed * 40 - 10;
        return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
          onClickAway: _this2.handleClickAway
        }, /*#__PURE__*/_react.default.createElement(_Grow.default, {
          in: open,
          id: "menu-list",
          style: {
            transformOrigin: '0 0 0'
          }
        }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
          style: maxOptionsDisplayed < 12 ? {
            maxHeight: 40 * maxOptionsDisplayed
          } : {},
          className: classes.paper
        }, (_this2.placement && _this2.placement.indexOf('bottom') >= 0 || staticPosition) && searchInput('bottom'), startAdornment, /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.default, (0, _extends2.default)({
          renderTrackHorizontal: _this2.renderScrollbarTrackHorizontal,
          renderTrackVertical: _this2.renderScrollbarTrackVertical,
          ref: function ref(contentEl) {
            _this2.optionsContent = contentEl;
          },
          autoHeight: true,
          autoHeightMax: autoHeightMax
        }, onScrollReachBottom && {
          onScroll: _this2.handleScroll
        }), /*#__PURE__*/_react.default.createElement(_HiSelectableList.default, (0, _extends2.default)({
          type: type,
          itemList: itemList,
          onSelect: _this2.handleSelect,
          selectedItemIdList: selectedItemIdList,
          fallbackImage: _this2.props.fallbackImage,
          overlay: _this2.overlay,
          value: value
        }, hiSelectableListProps))), _this2.placement && _this2.placement.indexOf('top') >= 0 && !staticPosition && searchInput('top'))));
      };
      return !_reactDeviceDetect.isMobile ? /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        ref: function ref(el) {
          _this2.overlay = el;
        },
        onKeyDown: this.handleKeyDown,
        onKeyDownCapture: this.handleKeyDownCapture
      }, alert && /*#__PURE__*/_react.default.createElement(_HiAlertModal.default, {
        open: alertOpen,
        title: alert.title,
        content: alert.content,
        onSubmitClick: this.handleSubmitAlert,
        onCancelClick: this.handleCancelAlert,
        onClose: this.handleCloseAlert,
        onExited: this.handleExitedAlert,
        labelSubmitButton: alert.submitButton,
        labelCancelButton: alert.cancelButton
      }), /*#__PURE__*/_react.default.createElement(_HiSelectInput.default, (0, _extends2.default)({
        id: id,
        value: inputValue,
        open: open,
        focused: focused,
        type: type,
        disabled: disabled,
        noButton: displayAsChip,
        error: error,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onSubmit: onSubmit,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onReset: this.props.onReset,
        placeholder: placeholder
      }, hiSelectInputProps, {
        refElement: function refElement(el) {
          _this2.inputEl = el;
        }
      })), open && staticPosition ? /*#__PURE__*/_react.default.createElement("div", {
        style: popperStyle,
        className: popperClass
      }, content({})) : /*#__PURE__*/_react.default.createElement(_Popper.default, {
        anchorEl: this.inputEl,
        placement: "bottom-start",
        open: open,
        className: popperClass,
        disablePortal: true,
        style: popperStyle
      }, content)) : /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(el) {
          _this2.overlay = el;
        }
      }, /*#__PURE__*/_react.default.createElement(_HiSelectInput.default, (0, _extends2.default)({
        id: id,
        value: inputValue,
        open: open,
        focused: focused,
        type: type,
        disabled: disabled,
        noButton: displayAsChip,
        error: error,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onReset: this.props.onReset,
        placeholder: placeholder
      }, hiSelectInputProps, {
        refElement: function refElement(el) {
          _this2.inputEl = el;
        }
      })), /*#__PURE__*/_react.default.createElement(_HiSelectMobile.default, {
        onChange: this.handleSelect,
        multiple: multiple,
        id: id,
        itemList: itemList,
        value: value,
        width: this.state.overlayWidth
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.options !== prevState.suggestions) {
        return (0, _objectSpread2.default)({}, prevState, {
          suggestions: nextProps.options
        });
      }
      return null;
    }
  }]);
}(_react.default.PureComponent);
HiSelect.defaultProps = {
  align: 'left',
  autoFocus: false,
  disabled: false,
  displayAsChip: false,
  error: false,
  hasAll: false,
  hiSelectableListProps: {},
  hiSelectInputProps: {},
  hiSearchInputProps: {},
  multiple: false,
  placeholder: '',
  searchable: false,
  staticPosition: false,
  translations: {
    all: 'All',
    no_result_match: 'No result match',
    search: 'Search',
    n_items_selected: '%s items selected',
    one_item_selected: '%s item selected',
    n_children: '%s items',
    one_child: '%s item'
  },
  type: 'text',
  filterFunc: filterValue,
  maxOptionsDisplayed: 12
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSelect'
})(HiSelect);